import { render } from "./CardPlans.vue?vue&type=template&id=93ed0750"
import script from "./CardPlans.vue?vue&type=script&lang=js"
export * from "./CardPlans.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__